// extracted by mini-css-extract-plugin
export default {"box":"options-menu_box__4jNlq","menu":"options-menu_menu__BujU0","link":"options-menu_link__UDrtZ","linkTitle":"options-menu_linkTitle__5Af1P"};